class MessageController {

  constructor(messageService) {
    this.messageService = messageService;
  }
}

MessageController.$inject = [ 'messageService' ];

export default MessageController;



// WEBPACK FOOTER //
// ./frontend/admin/app/modules/base/controllers/message.controller.js